export enum StowageStatusEnum {
    NotApplicable = 0,
    MissingStowage = 1,
    Stowed = 2,
    InvalidStowage = 3,
    DifferenceStowedUnstowedStowage = 4,
}
